import React, { useContext } from "react";
import { FavoritesContext } from "../../../../contexts/favorites";
import CasinoGame from "./game";

const CasinoGamesList = ({ games, disableFavoriteIcon }) => {
    const [{ casino: favorite }, changeFavorites] = useContext(FavoritesContext);

    if (!games?.length) return <p className="no-found-text">No games found</p>;

    const toggleFavorite = game => {
        const newFavorite = { ...favorite };

        if (favorite[game.id]) delete newFavorite[game.id];
        else newFavorite[game.id] = game;

        changeFavorites('casino', newFavorite);
    }
   
    return (
        <div className="casino-games-list">
            {games.map(item => <CasinoGame
                disableFavoriteIcon={disableFavoriteIcon}
                key={item.id}
                game={item}
                isFavorite={item.id in favorite}
                toggleFavorite={toggleFavorite}
            />)}
        </div>
    );
}

export default CasinoGamesList;